document.addRemoteEventListener('shown.bs.modal', '#video-presentation-modal', async () => {
    const { videoPresentationListener } = await import('@js/entrypoints/modals/videoPresentation');
    videoPresentationListener();
});

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((event) => {
    window.addEventListener(event, async () => {
        if (!('geolocation' in navigator)) {
            return;
        }
        const userLocation = document.querySelector('.js-user-location');

        if (!userLocation) {
            return;
        }
        const { locationListener } = await import('@js/entrypoints/modals/userLocation');
        locationListener();
    });
});
